/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import SteamLogin from '@/components/SteamLogin/index.vue';
import ProgressStatus from '@/components/ProgressStatus/index.vue';

const namespace: string = 'userSessionModule';

/**
 * Login page view component.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'v-login',
    components: {
        'c-steam-login': SteamLogin,
        'c-progress-status': ProgressStatus,
    },
})
export default class Login extends Vue {
    @Action('logout', {namespace}) public logout: any;
    @Getter('authenticated', {namespace}) public authenticated!: boolean;

    /**
     * Created lifecycle event.
     *
     * Important: we must perform a logout here.
     */
    public created(): void {
        if (this.authenticated) {
            this.logout();
        }
    }
}
